export const row_details = [
  {
    first_time: "08:00 - 08:45",
    first_hour: "1",
    first_lesson: "6283 Sayılı Hemşirelik Kanunu",
    first_lecturer: "Prof. Dr. Ülkü BAYKAL",
    first_topic:
      "Hemşirelik Kanunu kapsamında hemşirenin rol ve sorumlulukları",
    first_detail:
      "Hemşirelik Kanununun amacı, kapsamı nedir? /Hemşirelik Kanuna göre hemşire kime denir? Hemşirelerin görev ve sorumlukları nelerdir? /Yönetimde rüçhan hak kavramı nedir? /Tarihsel süreçte hemşirelik kanununda yapılan değişikler nelerdir?",
    second_time: "08:00 - 08:45",
    second_hour: "1",
    second_lesson: "5237 sayılı Türk Ceza Kanunu",
    second_lecturer: "Doç. Dr. Hüsnü Sefa ERYILDIZ",
    second_topic:
      "Hemşireleri ilgilendiren 5237 sayılı Türk Ceza Kanunu Maddeleri",
    second_detail:
      "Türk Ceza Kanunun Amacı /Suçta ve Cezada Kanunilik ilkesinin tanımı/Adalet ve Kanun Önünde Eşitlik ilkesinin tanımı/Kanunun Bağlayıcılığının tanımı/ Ceza Sorumluluğunun şahsiliği nedir? / Kast/Olası Kast, Taksir/Bilinçli Taksir nedir? 5237 sayılı TCK’daki sağlık personelleriyle ilgili taksirli suçlar nelerdir? 5237 sayılı TCK’ da sağlık personelini ilgilendiren, netice sebebiyle ağırlaşmış suçlar nelerdir?",
  },
  {
    first_time: "09:00 - 09:45",
    first_hour: "1",
    first_lesson: "27515 Sayılı Hemşirelik Yönetmeliği",
    first_lecturer: "Doç. Dr. Handan ALAN",
    first_topic:
      "Hemşirelik Yönetmeliği kapsamında hemşirenin rol ve sorumlulukları",
    first_detail:
      "Hemşirelik Yönetmeliğinin amaç ve kapsamı nedir? /Hemşirelik hizmetlerinin kapsamı, hemşirelerin görev, yetki ve sorumlulukları nelerdir? Uzman Hemşire ve Yetki Belgesine Sahip Hemşirelerin görev, yetki ve sorumlulukları/ Hemşirelik Hizmetlerinin Yönetimi ve Organizasyonun açıklanması",
    second_time: "09:00 - 09:45",
    second_hour: "1",
    second_lesson: "5237 sayılı Türk Ceza Kanunu",
    second_lecturer: "Doç.Dr. Hüsnü Sefa ERYILDIZ",
    second_topic:
      "Hemşireleri ilgilendiren 5237 sayılı Türk Ceza Kanunu Maddeleri",
    second_detail:
      "Madde 20- “Ceza sorumluluğunun şahsiliği”, Madde 24- “Kanunun hükmü ve amirin emri”, Madde 26- “Hakkın kullanılması ve ilgilinin rızası”, Madde 28- “Cebir ve şiddet, korkutma ve tehdit”, Madde 34- “Geçici nedenler, alkol veya uyuşturucu madde etkisinde olma”, Madde 39- “Yardım etme” nin açıklanması",
  },
  {
    first_time: "10:00 - 10:45",
    first_hour: "1",
    first_lesson: "Hemşirelikte Profesyonel Değerler ve Davranışlar",
    first_lecturer: "Doç. Dr. Eylem PASLI GÜRDOĞAN",
    first_topic:
      "Hemşirelikte Değerler ve Profesyonel Davranışlar: Mesleki kimliği oluşturan değerlerin gelişimi ve profesyonel davranışların tanıtılması ",
    first_detail:
      "Değer Kavramı ve Özellikleri/ Değerlerin Gelişimi/ Değerlerin Sınıflandırılması/ Hemşirelikte Profesyonel Değerler",
    second_time: "10:00 - 10:45",
    second_hour: "1",
    second_lesson: "5237 sayılı Türk Ceza Kanunu",
    second_lecturer: "Dr. Öğr. Üyesi Bilgehan SAVAŞCI TEMİZ",
    second_topic:
      "Hemşireleri ilgilendiren 5237 sayılı Türk Ceza Kanunu Maddeleri",
    second_detail:
      "Madde 81- “Kasten öldürme”, Madde 83- “Kasten öldürmenin ihmali davranışla işlenmesi”, Madde 85- “Taksirle Öldürme”, Madde 86- “Kasten Yaralama”, Madde 87- “Neticesi Sebebiyle Ağırlaşmış Yaralama”, Madde 88- “Kasten Yaralamanın ihmali Davranışla işlenmesi” nin açıklanması",
  },
  {
    first_time: "11:00 - 11:45",
    first_hour: "1",
    first_lesson: "Hemşirelikte Profesyonel Değerler ve Davranışlar ",
    first_lecturer: "Doç. Dr. Eylem PASLI GÜRDOĞAN",
    first_topic:
      "Hemşirelikte Değerler ve Profesyonel Davranışlar: Profesyonel değer ve davranışların hemşirelikte uygulanması",
    first_detail:
      "Değerlerin Belirlenmesinin Hemşirelik Mesleğine Sağladığı Yarar/ Hemşirelikte Profesyonel Davranışlar",
    second_time: "11:00 - 11:45",
    second_hour: "1",
    second_lesson: "5237 sayılı Türk Ceza Kanunu",
    second_lecturer: "Dr. Öğr. Üyesi Bilgehan SAVAŞCI TEMİZ",
    second_topic:
      "Hemşireleri ilgilendiren 5237 sayılı Türk Ceza Kanunu Maddeleri",
    second_detail:
      "Madde 89- “Taksirle yaralama”, Madde 90- “İnsan üzerinde deney”, Madde 91- “Organ veya doku ticareti”, Madde 94 “İşkence”, Madde 97- “Terk”, Madde 98- “Yardım veya bildirim yükümlülüğünün yerine getirilmemesi”, Madde 121- “Dilekçe hakkının kullanılmasının engellenmesi”, Madde 124- “Haberleşmenin engellenmesi” nin açıklanması.",
  },
  {
    first_time: "12:00 - 12:45",
    first_hour: "1",
    first_lesson: "Adli Tıp/ Adli Hemşirelik",
    first_lecturer: "Prof. Dr. Ahmet Nezih KÖK",
    first_topic: "Adli vaka ve adli hemşirelik kavramları",
    first_detail:
      "Adli vaka nedir? Adli Hemşireliğin tanımı/Adli hemşireliğin görev ve sorumlukları/Yaralama ya da ölüm sonuçlanan durumlara ait adli soruşturmalarda, olayların tıbbi yönleri nasıl aydınlatılır?",
    second_time: "12:00 - 12:45",
    second_hour: "1",
    second_lesson: "5237 sayılı Türk Ceza Kanunu",
    second_lecturer: "Prof. Dr. Cem ŞENOL",
    second_topic:
      "Hemşireleri ilgilendiren 5237 sayılı Türk Ceza Kanunu Maddeleri",
    second_detail:
      "Madde 134- “Özel hayatın gizliliğini ihlal”, Madde 135- “Kişisel verilerin kaydedilmesi”, Madde 136- “Verileri hukuka aykırı olarak verme veya ele geçirme”, Madde 175- “Akıl hastası üzerindeki bakım ve gözetim yükümlülüğünün ihlali”, Madde 204- “Resmi belgede sahtecilik”, Madde 205- “Resmî belgeyi bozmak, yok etmek veya gizlemek”, Madde 206- “Resmi belgenin düzenlenmesinde yalan beyan”, Madde 231- “Çocuğun Soy Bağını Değiştirme”, Madde 258- “Göreve ilişkin sırrın açıklanması”, Madde 280- “Sağlık mesleği mensuplarının suçu bildirmemesi”.",
  },
  {
    first_time: "14:00 - 14:45",
    first_hour: "1",
    first_lesson: "Adli Tıp/ Adli Hemşirelik",
    first_lecturer: "Prof. Dr. Ahmet Nezih KÖK",
    first_topic:
      "Adli vaka yaklaşımında hemşirelik/ Konuya İlişkin Adli Vaka Sunumu",
    first_detail:
      "Örnek adli vaka sunumu/ Hemşirelerin adli vakalarda yasal sorulukları nelerdir?",
    second_time: "14:00 - 14:45",
    second_hour: "1",
    second_lesson: "Tıbbi Hata (Malpraktis)",
    second_lecturer: "Dr. Öğr. Üyesi Özgür Temiz",
    second_topic:
      "Tıbbi Hata kavramı ve tıbbi hataların vasıflandırılması.ve bildirim sistemleri",
    second_detail:
      "Tıbbi hata kavramı/Tıbbi hataların meslek mensupları arasında paylaştırılması/ Tıbbi hatalar ile kişsel kusurun ayrılması/ Hizmet kusuru teşkil eden tıbbi hatalarda sorumluluğun tespiti/Hemşirelerin tedavi sürecindeki hukuki statüsünün tespiti/ Hemşirelerin kişisel kusurları ile hizmet kusurlarının ayrımının yapılması.",
  },
  {
    first_time: "15:00 - 15:45",
    first_hour: "1",
    first_lesson: "Hasta Güvenliği",
    first_lecturer: "Prof. Dr. Şeyda SEREN İNTEPELER",
    first_topic: "Hasta güvenliği kavramı ve hasta güvenliği standartları",
    first_detail:
      "Hasta güvenliği kavramı nedir? /Hasta güvenliğinin önemi nedir? / Hasta güvenliği yönetmeliği kapsamında hasta güvenliği önlemleri nelerdir? / Hasta güvenliği uygulamaları nelerdir? /Uluslararası hasta güvenliği hedefleri nelerdir/Hemşirenin hasta güvenliğine ilişkin rol ve sorumlulukları nelerdir?",
    second_time: "15:00 - 15:45",
    second_hour: "1",
    second_lesson: "Tıbbi Hata (Malpraktis)",
    second_lecturer: "Dr. Öğr. Üyesi Özgür Temiz",
    second_topic:
      "Tıbbi hatalar nedeniyleın sınıflandırılması ve hemşirelerin idari, hukuki ve etikhukuki sorumlulukları",
    second_detail:
      "Kamu kesiminde görev yapan hemşirelerin tıbbi uygulama hataları nedeniyle idari sorumluluğu; disiplin sorumluluğu ve rücu mekanizması. Özel kesimde çalışan hemşirelerin tıbbi uygulama hataları nedeniyle işverene karşı sorumlulukları ve tazminat sorumluluğu. Hemşirelerin tıbbi uygulama hatası nedeniyle etik sorumluluğu/Konuyla ilgili yargısal içtihatların değerlendirilmesi.",
  },
  {
    first_time: "16:00 - 16:45",
    first_hour: "1",
    first_lesson: "Hasta Hakları",
    first_lecturer: "Prof. Dr. Havva ÖZTÜRK",
    first_topic:
      "Hasta Haklarının korunmasında hemşirenin rol ve sorumlulukları ve vaka sunumu",
    first_detail:
      "Hasta haklarının tanımı/Hasta haklarının tarihsel gelişimi/Hasta haklarına ilişkin yasal mevzuatlar/Hasta haklarının sınıflandırılması / Dünyada hasta hakları uygulamaları /Türkiye’de hasta hakları uygulamaları / Hasta haklarının korunmasında hemşirenin rol ve sorumlulukları",
    second_time: "",
    second_hour: "",
    second_lesson: "",
    second_lecturer: "",
    second_topic: "",
    second_detail: "",
  },
];
